// QuotationPreview.js
import React from "react";
import { Document, Page, Text, View } from "@react-pdf/renderer";
import Header from "../components/quotation-preview/Header";
import Content from "../components/quotation-preview/Content";
import Footer from "../components/quotation-preview/Footer";
import { styles } from "./styles";
import { Font } from "@react-pdf/renderer";

Font.register({
  family: "NotoSansThai",
  fonts: [
    { src: "/fonts/NotoSansThai-Regular.ttf" }, // Regular
    { src: "/fonts/NotoSansThai-Bold.ttf", fontWeight: "bold" }, // Bold
  ],
});

const QuotationPreview = ({ quotationData, bankInfo, isDetailedForm }) => {
  const MAX_ITEMS_PER_PAGE = isDetailedForm ? 4 : 10; // ✅ กำหนดจำนวน items ต่อหน้า

  let pages = [];
  let currentPage = [];
  let currentLines = 0;
  let currentStartIndex = 0; // ✅ ติดตาม index ของรายการที่เพิ่ม

  quotationData.items.forEach((item, index) => {
    if (currentLines >= MAX_ITEMS_PER_PAGE) {
      pages.push({ items: currentPage, startIndex: currentStartIndex }); // ✅ ใช้ startIndex ที่สะสม
      currentStartIndex += currentPage.length; // ✅ อัปเดต startIndex สำหรับหน้าถัดไป
      currentPage = [];
      currentLines = 0;
    }
    currentPage.push(item);
    currentLines++;
  });

  if (currentPage.length > 0) {
    pages.push({ items: currentPage, startIndex: currentStartIndex });
  }

  return (
    <Document>
    {pages.map(({ items, startIndex }, pageIndex) => (
      <Page key={pageIndex} size="A4" style={styles.page}>
        <Header quotationData={quotationData} />
        <Content quotationData={{ ...quotationData, items }} startIndex={startIndex} />
        {pageIndex === pages.length - 1 && <Footer quotationData={quotationData} bankInfo={bankInfo} />}

        {/* ✅ เพิ่มหมายเลขหน้า */}
        <View style={styles.pageNumber}>
            <Text>{pageIndex + 1} / {pages.length}</Text>
        </View>
      </Page>
    ))}
  </Document>
  );
};

export default QuotationPreview;
